import {SET_NAV_VALUES} from  './actionTypes'

export const setNavValues = navValues => {

  return {
    type: SET_NAV_VALUES,
    payload: { state: navValues },
  }
}